// @ts-strict-ignore
import * as React from 'react';
import clsx from 'clsx';
import { SetupGuideContext, Step, UserEventPropertiesMapContext } from 'common/onboarding/immersive-onboarding/types';
import { useTranslation } from 'common/i18n/hooks';
import { PropertyBreakdownPreviewCarouselV2 } from '../chart-preview';
import { getBreakdownValues } from '../util';
import styles from './index.module.styl';
import { EventColumn } from './event-column';
import { PropertyColumn } from './property-column';
import { ConnectorWrapper } from './connector';
const BreakdownPreviewSectionCompleted = _ref => {
  let {
    selectedEvent,
    selectedProperty,
    setSelectedEvent,
    setSelectedProperty
  } = _ref;
  const {
    eventKeys
  } = React.useContext(UserEventPropertiesMapContext);
  const translation = useTranslation();
  const event = !selectedEvent || !eventKeys.includes(selectedEvent) ? eventKeys[0] : selectedEvent;
  return <div className={clsx(styles.breakdownContent, styles.narrow)} data-sentry-component="BreakdownPreviewSectionCompleted" data-sentry-source-file="index.tsx">
      <div className={clsx(styles.selectorContainer, styles.narrowSelectorContainer)}>
        <ConnectorWrapper data-sentry-element="ConnectorWrapper" data-sentry-source-file="index.tsx">
          <EventColumn selectedEvent={event} setSelectedEvent={setSelectedEvent} skipAnimation data-sentry-element="EventColumn" data-sentry-source-file="index.tsx" />
          <PropertyColumn selectedEvent={event} setSelectedProperty={setSelectedProperty} selectedProperty={selectedProperty} skipAnimation data-sentry-element="PropertyColumn" data-sentry-source-file="index.tsx" />
        </ConnectorWrapper>
      </div>
      <div className={clsx(styles.preview, styles.narrowPreview)}>
        <PropertyBreakdownPreviewCarouselV2 pauseRotation={!selectedProperty} events={eventKeys} selectedEvent={event} property={selectedProperty} breakdown={getBreakdownValues({
        property: selectedProperty,
        i18n: translation
      })} data-sentry-element="PropertyBreakdownPreviewCarouselV2" data-sentry-source-file="index.tsx" />
      </div>
    </div>;
};

/* eslint-disable react/destructuring-assignment */
const BreakdownPreviewSection = _ref2 => {
  let {
    showProperties,
    setShowProperties,
    selectedEvent,
    setSelectedProperty,
    setSelectedEvent,
    selectedProperty
  } = _ref2;
  const {
    currentEventPropertiesMap,
    eventKeys
  } = React.useContext(UserEventPropertiesMapContext);
  const translation = useTranslation();
  React.useEffect(() => {
    let timerId;
    if (selectedEvent) {
      timerId = setTimeout(() => {
        setShowProperties(true);
      }, 500);
    }
    return () => {
      if (timerId) clearTimeout(timerId);
    };
  }, [selectedEvent]);

  // select first property when event is selected
  React.useEffect(() => {
    var _currentEventProperti;
    if (selectedEvent) setSelectedProperty(((_currentEventProperti = currentEventPropertiesMap[selectedEvent]) === null || _currentEventProperti === void 0 ? void 0 : _currentEventProperti[0]) || null);
  }, [selectedEvent]);
  return <div className={clsx(styles.breakdownContent, {
    [styles.narrow]: selectedEvent
  })} data-sentry-component="BreakdownPreviewSection" data-sentry-source-file="index.tsx">
      <div className={clsx(styles.selectorContainer, {
      [styles.narrowSelectorContainer]: selectedEvent
    })}>
        <ConnectorWrapper data-sentry-element="ConnectorWrapper" data-sentry-source-file="index.tsx">
          <EventColumn selectedEvent={selectedEvent} setSelectedEvent={setSelectedEvent} data-sentry-element="EventColumn" data-sentry-source-file="index.tsx" />
          {selectedEvent && showProperties && <PropertyColumn selectedEvent={selectedEvent} setSelectedProperty={setSelectedProperty} selectedProperty={selectedProperty} />}
        </ConnectorWrapper>
      </div>
      <div className={clsx(styles.preview, {
      [styles.blur]: !selectedProperty,
      [styles.narrowPreview]: selectedEvent
    })}>
        <PropertyBreakdownPreviewCarouselV2 pauseRotation={!selectedProperty} events={eventKeys} selectedEvent={selectedEvent} property={selectedProperty} breakdown={getBreakdownValues({
        property: selectedProperty,
        i18n: translation
      })} data-sentry-element="PropertyBreakdownPreviewCarouselV2" data-sentry-source-file="index.tsx" />
      </div>
    </div>;
};
export const EventSubsteps = _ref3 => {
  let {
    showProperties,
    setShowProperties,
    selectedProperty,
    setSelectedProperty
  } = _ref3;
  const {
    completed
  } = React.useContext(SetupGuideContext);
  const [selectedEvent, setSelectedEvent] = React.useState<string>(null);
  if (completed[Step.Events]) {
    return <BreakdownPreviewSectionCompleted selectedEvent={selectedEvent} setSelectedProperty={setSelectedProperty} setSelectedEvent={setSelectedEvent} selectedProperty={selectedProperty} />;
  }
  return <BreakdownPreviewSection showProperties={showProperties} setShowProperties={setShowProperties} selectedEvent={selectedEvent} setSelectedProperty={setSelectedProperty} setSelectedEvent={setSelectedEvent} selectedProperty={selectedProperty} data-sentry-element="BreakdownPreviewSection" data-sentry-component="EventSubsteps" data-sentry-source-file="index.tsx" />;
};